import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lib-workflows',
  templateUrl: './workflows.component.html'
})
export class WorkflowsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
